var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { useEffect, useState } from 'react';
import fetchWithTimeout from '../utils/fetchWithTimeout';
import analytics from '../analytics/analytics';
const usePostSurveyContent = variables => {
  const [isAnswersSent, setIsAnswersSent] = useState(false);
  useEffect(() => {
    var _a;
    const postIt = () => __awaiter(void 0, void 0, void 0, function* () {
      const url = `/genai-svc/genai/survey/send-answers`;
      const response = yield fetchWithTimeout(url, {
        method: 'POST',
        body: JSON.stringify({
          encodedId: variables === null || variables === void 0 ? void 0 : variables.encodedId,
          answers: variables === null || variables === void 0 ? void 0 : variables.answers
        })
      });
      if (response.ok) {
        const result = yield response.json();
        setIsAnswersSent(result.isAnswersSent);
      }
    });
    if (((_a = variables === null || variables === void 0 ? void 0 : variables.answers) === null || _a === void 0 ? void 0 : _a.length) && (variables === null || variables === void 0 ? void 0 : variables.encodedId)) {
      postIt().catch(e => {
        analytics.log({
          message: e.message,
          source: 'usePostSurveryContent'
        });
      });
    }
  }, [variables]);
  return {
    isAnswersSent
  };
};
export default usePostSurveyContent;